module.exports = __webpack_public_path__ + "static/media/galdisa_banner2.36b56fd1.jpg";